

export default {
    Challenger : "challenger",
    Challenged : "challenged"
}
